module.exports = __webpack_public_path__ + "media/Heroimage-720p.553ae6d7.mp4";